import { useState, VFC } from 'react'
import { useForm } from 'react-hook-form'
import { updateScheduleUrlBannerLastClosedAt } from 'src/api/user'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { black, truewhite, _formalert, _profilegreen } from 'src/styles/colors'
import { fontWeightBold, fontWeightMedium } from 'src/styles/font'
import styled from 'styled-components'

const ScheduleUrlBannerClose: VFC<ModalProps<{}>> = ({ close }) => {
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useForm()
  const [error, setError] = useState('')

  const handleOnSubmit = async ({}) => {
    const res = await updateScheduleUrlBannerLastClosedAt()
    if (res.error) setError(res.error.errorMessages?.join('\n'))
    else close()
  }

  return (
    <Layout>
      <FormTitle>日程調整URL登録案内を非表示にしますか？</FormTitle>
      <FormCaption>
        クリックすると2週間、URL登録バナーが非表示になります
      </FormCaption>
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <ErrorMessage>
          <p>{error}</p>
        </ErrorMessage>
        <ModalButtons>
          <CancelButton type="button" onClick={close}>
            キャンセル
          </CancelButton>
          <SaveButton type="submit" disabled={isSubmitting}>
            非表示
          </SaveButton>
        </ModalButtons>
      </form>
    </Layout>
  )
}

export const ScheduleUrlBannerCloseModal = asModal(ScheduleUrlBannerClose)

const Layout = styled.div`
  width: 80vw;
  max-width: 400px;
  padding: 5%;
  border-radius: 10px;
  background-color: ${truewhite};
  line-height: 1.3rem;
`

const FormTitle = styled.h2`
  font-size: 17px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: left;
  font-weight: ${fontWeightBold};
`

const FormCaption = styled.p`
  margin-bottom: 40px;
  font-size: 13px;
  color: ${black};
  font-weight: ${fontWeightMedium};
`

const ErrorMessage = styled.div`
  color: ${_formalert};
  margin-top: 10px;
`

const ModalButtons = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
  justify-content: flex-end;

  button {
    text-align: center;
    padding: 5px 21px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: ${fontWeightBold};
    line-height: 1.4;
    white-space: normal;
  }

  @media screen and (max-width: 540px) {
    display: block;
  }
`

const SaveButton = styled.button`
  color: ${truewhite};
  background: ${_profilegreen};
`

const CancelButton = styled.button`
  color: ${_profilegreen};
`
